"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TitleStyled = exports.Description = exports.Container = exports.Claim = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _palette = require("../../../styles/palette");

var _widths = require("../../../styles/widths");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var Claim = _styledComponents["default"].h3(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  color      : ", ";\n  font-size  : 32px;\n  font-weight: ", ";\n  margin     : ", "px 0;\n"])), function (props) {
  return props.claimColor ? props.claimColor : _palette.palette.bobBlack;
}, _widths.font.semi, _widths.widths.base);

exports.Claim = Claim;
Claim.displayName = 'Claim';

var Container = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  text-align: left;\n"])));

exports.Container = Container;
Container.displayName = 'Container';

var Description = _styledComponents["default"].p(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n  color      : ", ";\n  font-size  : 14px;\n  font-weight: ", ";\n  margin     : 0;\n"])), function (props) {
  return props.claimColor ? props.claimColor : _palette.palette.bobBlack;
}, _widths.font.regular);

exports.Description = Description;
Description.displayName = 'Description';

var TitleStyled = _styledComponents["default"].h2(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n  align-items: center;\n  color      : ", ";\n  display    : flex;\n  font-size  : 14px;\n  font-weight: ", ";\n  margin     : 0;\n\n  &:before {\n    border-bottom: ", ";\n    content      : \"\";\n    margin-right : ", "px;\n    width        : ", "px;\n  }\n"])), function (props) {
  return props.titleColor ? props.titleColor : _palette.palette.grey;
}, _widths.font.regular, function (props) {
  return props.titleColor ? "solid 1px ".concat(props.titleColor) : "solid 1px ".concat(_palette.palette.grey);
}, _widths.widths.base, _widths.widths.base * 4);

exports.TitleStyled = TitleStyled;
TitleStyled.displayName = 'TitleStyled';